import React, { useState } from 'react';

const ShowExamples = () => {
    const [examples, setExamples] = useState([
        {
            nombre: 'SUB-JA-2021-166663',
            num_lotes: 1,
            valor_subasta: 60686.74,
            valor_cargas: 114983.67,
            descripcion: 'Un apartamento en Vielha',
            link: '/subasta/ejemplo-2',
        },
        {
            nombre: 'SUB-JV-2024-228866',
            num_lotes: 1,
            valor_subasta: 156736.43,
            valor_cargas: 0,
            descripcion: 'Diversos lotes en Benasque',
            link: '/subasta/ejemplo-1',
        },
        {
            nombre: 'SUB-JA-2024-238960',
            num_lotes: 1,
            valor_subasta: 119056.02,
            valor_cargas: 12127.06,
            descripcion: 'Un piso en Madrid',
            link: '/subasta/ejemplo-3',
        }
    ]);

    return (
        <>
            <p className="mt-10 text-xl text-white">
                {
                    //Nada Que Ganar, Kaizen, Heavy Mental y muchos más
                }
            </p>
            <div className="flex flex-col justify-between bg-blueGray-50 py-4 px-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold text-gray-700 text-left pt-1 pb-6">Echa un vistazo a estos análisis 👀</h3>
                <div className="grid grid-cols-1 gap-4">
                    {examples.map((subasta, index) => {
                        return (
                            <a
                                className={`flex flex-col justify-between bg-white p-4 rounded-lg shadow-md cursor-pointer transition-transform transform hover:scale-105 hover:bg-gray-100`}
                                key={index}
                                href={subasta.link}
                            >
                                <div className='flex flex-col items-start'>
                                    <div className="flex items-start justify-between">
                                        <h2 className="text-lg font-semibold text-gray-700">{subasta.nombre}</h2>
                                    </div>
                                    <p className="text-sm text-gray-600 text-left">{subasta.descripcion}</p>
                                    <p className="mt-2 text-sm font-normal text-gray-600 dark:text-gray-400">
                                        <i className="fas fa-sack-dollar mr-2"></i>
                                        <span className="mr-1">Valor de tasación:</span>
                                        {parseFloat(subasta.valor_subasta).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}
                                    </p>
                                    <p className="text-sm font-normal text-gray-600 dark:text-gray-400">
                                        <i className="fas fa-triangle-exclamation mr-2"></i>
                                        <span className="mr-1">Cargas no canceladas:</span>
                                        {parseFloat(subasta.valor_cargas).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}
                                    </p>
                                </div>
                            </a>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

export default ShowExamples;